import PrivateBurger from './PrivateBurger';
export default PrivateBurger;
